var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('user-details-edit',{attrs:{"data":_vm.newUserData,"status":"new"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }